import React, { useEffect } from "react";
import { primaryColor, secondaryColor } from "../colors";
import { Footer } from "../Footer";
import { Background } from "../home/Background";
import { DownloadSection } from "../home/DownloadSection";
import { HomeSection } from "../home/HomeSection";
import { DeviceWidth, useDeviceWidthQuery } from "../MediaQuery";
import analytics from "../services/analytics";
import { SizedBox } from "../SizedBox";
import { language, translation } from "../translations";
import { Header2 } from "../typography";
import { nl2br } from "../utils";
import { Header } from "./Header";
import { teamMembers } from "./members";

const Team: React.FC = () => {
  useEffect(() => {
    analytics.logPageView("team");
  }, []);

  return (
    <Background>
      <Header />
      <HomeSection>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Header2 color={secondaryColor}>{translation.ourTeam}</Header2>
          <SizedBox desktopHeight={24} mobileHeight={16} />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {teamMembers.map((member) => {
              const info = language === "pl" ? member.infoPl : member.infoEn;
              return (
                <TeamMemberCard
                  key={member.imageSrc}
                  imageSrc={member.imageSrc}
                  name={info.name}
                  title={info.title}
                  bio={info.bio}
                />
              );
            })}
          </div>
        </div>
      </HomeSection>
      <DownloadSection />
      <Footer />
    </Background>
  );
};

const TeamMemberCard: React.FC<{
  imageSrc: string;
  name: string;
  title: string;
  bio: string;
}> = (props) => {
  const deviceWidth = useDeviceWidthQuery();

  const buildText = (text: string, fontSize: number) => (
    <div
      style={{
        fontSize: fontSize,
        color: primaryColor,
        textTransform: "uppercase",
        textAlign: "center",
        fontWeight: 500,
      }}
    >
      {nl2br(text)}
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        width: {
          [DeviceWidth.mobile]: 282,
          [DeviceWidth.desktop]: 340,
        }[deviceWidth],
        borderRadius: 4,
        backgroundColor: "white",
        boxShadow: "0px 1px 6px 0px rgba(0,0,0,0.2)",
        margin: 10,
        padding: 16,
      }}
    >
      <img
        style={{
          boxShadow: "8px 8px 0px 0px rgb(49, 91, 246)",
          marginBottom: 18,
        }}
        width={120}
        src={props.imageSrc}
        alt={props.name}
      />
      <div style={{ marginBottom: 5 }}>{buildText(props.name, 21)}</div>
      {buildText(props.title, 16)}
      <p
        style={{
          textAlign: "center",
          fontWeight: 400,
        }}
      >
        {props.bio}
      </p>
    </div>
  );
};

export default Team;
